import { X } from '@phosphor-icons/react'
import { ButtonHTMLAttributes, forwardRef } from 'react'

import cn from '@/utils/tailwind/cn'

export const DropdownCloseButton = forwardRef<
  HTMLButtonElement,
  ButtonHTMLAttributes<HTMLButtonElement>
>(({ className, ...props }, ref) => (
  <button
    className={cn(
      'absolute -right-2.5 -top-2.5 flex h-5 w-5 items-center justify-center rounded-full bg-gray-600 outline-none focus:outline-none',
      className
    )}
    ref={ref}
    {...props}
  >
    <X className="text-xs text-white" weight="bold" />
  </button>
))
